import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { isMobile } from 'react-device-detect';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';
import PropTypes from 'prop-types';
import {
  downloadPdfFile as downloadFileCallback,
  viewPdfFile as viewFileCallback,
  printPdfFile as printPdfFileCallback,
  getTaxInvoicePdfFileName,
} from '../utils/pdfUtils';
import Table from '../common/table';
import { actionCreators } from './store.js';
import TaxInvoiceAction from './TaxInvoiceAction';
import { ReactComponent as ViewIcon } from '../assets/view.svg';
import { ReactComponent as DownloadIcon } from '../assets/download.svg';
import { ReactComponent as PrintIcon } from '../assets/print.svg';

const styles = (theme) => ({
  row: {
    cursor: 'pointer',
  },
  actionContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginRight: '15px',
  },
});

const tableMetadata = [
  {
    id: 'startPeriod',
    renderingField: 'month',
    width: 'auto',
    label: 'Month',
    alignment: 'left',
  },
  {
    id: 'periodCovered',
    renderingField: 'periodCovered',
    width: 'auto',
    hideInMobile: true,
    disableColumnSorting: true,
    label: 'Period covered',
    alignment: 'left',
  },
  {
    id: 'action',
    renderingField: 'action',
    width: 'auto',
    disableColumnSorting: true,
    disableCellPadding: true,
    label: '',
    alignment: 'right',
  },
];

class TaxInvoiceList extends React.PureComponent {
  handleDownloadInvoice = (e, item) => {
    e.stopPropagation();
    const { getTaxInvoiceAsPdf } = this.props;
    const { adfitNo, startPeriod } = item;
    const fileName = getTaxInvoicePdfFileName(adfitNo, startPeriod);
    getTaxInvoiceAsPdf(
      adfitNo,
      moment(startPeriod).format('YYYY-MM-DD'),
      fileName,
      downloadFileCallback
    );
  };

  handleViewInvoice = (e, item) => {
    e.stopPropagation();
    const { getTaxInvoiceAsPdf } = this.props;
    const { adfitNo, startPeriod } = item;
    const fileName = getTaxInvoicePdfFileName(adfitNo, startPeriod);
    getTaxInvoiceAsPdf(
      adfitNo,
      moment(startPeriod).format('YYYY-MM-DD'),
      fileName,
      viewFileCallback
    );
  };

  handlePrintInvoice = (e, item) => {
    e.stopPropagation();
    const { getTaxInvoiceAsPdf } = this.props;
    const { adfitNo, startPeriod } = item;
    const fileName = getTaxInvoicePdfFileName(adfitNo, startPeriod);
    getTaxInvoiceAsPdf(
      adfitNo,
      moment(startPeriod).format('YYYY-MM-DD'),
      fileName,
      printPdfFileCallback
    );
  };

  getTaxInvoicesTableData = ({ adfitNo, taxInvoices, classes }) => {
    return taxInvoices.map((taxInvoice) => {
      const item = { ...taxInvoice, adfitNo };
      return {
        ...item,
        id: item.startPeriod,
        month: moment(taxInvoice.startPeriod).format('MMMM YYYY'),
        periodCovered: `${moment(taxInvoice.startPeriod).format(
          'DD MMM YYYY'
        )} - ${moment(taxInvoice.endPeriod).format('DD MMM YYYY')}`,
        action: (
          <div className={classes.actionContainer}>
            {isMobile ? (
              <TaxInvoiceAction
                label="View"
                taxInvoice={item}
                onClick={this.handleDownloadInvoice}
              />
            ) : (
              <>
                <TaxInvoiceAction
                  label="View"
                  icon={ViewIcon}
                  taxInvoice={item}
                  onClick={this.handleViewInvoice}
                  hideIconInMobile={true}
                />
                <TaxInvoiceAction
                  label="Download"
                  icon={DownloadIcon}
                  taxInvoice={item}
                  onClick={this.handleDownloadInvoice}
                  hideActionInMobile={true}
                />
                <TaxInvoiceAction
                  label="Print"
                  icon={PrintIcon}
                  taxInvoice={item}
                  onClick={this.handlePrintInvoice}
                  hideActionInMobile={true}
                />
              </>
            )}
          </div>
        ),
      };
    });
  };

  render() {
    const {
      adfitNo,
      taxInvoices,
      currentPage,
      onPageChange,
      handleRowClick,
      classes,
    } = this.props;

    const tableData = Array.isArray(taxInvoices)
      ? this.getTaxInvoicesTableData({ adfitNo, taxInvoices, classes })
      : [];

    return (
      <Table
        data={tableData}
        metadata={tableMetadata}
        orderBy={'startPeriod'}
        order={'desc'}
        onRowClick={handleRowClick}
        enableSorting={true}
        showEmptyRows={true}
        showFooter={true}
        noBackground={false}
        currentPage={currentPage}
        onPageChange={onPageChange}
      />
    );
  }
}

TaxInvoiceList.propTypes = {
  adfitNo: PropTypes.string,
  taxInvoices: PropTypes.arrayOf(PropTypes.object),
  classes: PropTypes.object.isRequired,
};

export default compose(
  connect(null, {
    getTaxInvoiceAsPdf: actionCreators.getTaxInvoiceAsPdf,
  }),
  withStyles(styles)
)(TaxInvoiceList);
